var C = Object.defineProperty;
var R = (o, a, e) => a in o ? C(o, a, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[a] = e;
var y = (o, a, e) => R(o, typeof a != "symbol" ? a + "" : a, e);
import h from "axios";
const d = "/api".replace(/\/+$/, "");
class S {
  constructor(a, e = d, r = h) {
    y(this, "configuration");
    this.basePath = e, this.axios = r, a && (this.configuration = a, this.basePath = a.basePath || this.basePath);
  }
}
class U extends Error {
  constructor(a, e) {
    super(e), this.field = a, this.name = "RequiredError";
  }
}
const p = "https://example.com", A = function(o, a, e) {
  if (e == null)
    throw new U(a, `Required parameter ${a} was null or undefined when calling ${o}.`);
};
function _(o, a, e = "") {
  a != null && (typeof a == "object" ? Array.isArray(a) ? a.forEach((r) => _(o, r, e)) : Object.keys(a).forEach(
    (r) => _(o, a[r], `${e}${e !== "" ? "." : ""}${r}`)
  ) : o.has(e) ? o.append(e, a) : o.set(e, a));
}
const O = function(o, ...a) {
  const e = new URLSearchParams(o.search);
  _(e, a), o.search = e.toString();
}, P = function(o, a, e) {
  const r = typeof o != "string";
  return (r && e && e.isJsonMime ? e.isJsonMime(a.headers["Content-Type"]) : r) ? JSON.stringify(o !== void 0 ? o : {}) : o || "";
}, m = function(o) {
  return o.pathname + o.search + o.hash;
}, E = function(o, a, e, r) {
  return (t = a, s = e) => {
    const n = { ...o.options, url: ((r == null ? void 0 : r.basePath) || s) + o.url };
    return t.request(n);
  };
}, N = {
  PROJECT: "project"
}, L = {
  PUBLIC: "public",
  PRIVATE: "private"
}, w = {
  COUNT: "count",
  CREDITS: "credits",
  BANDWIDTH: "bandwidth"
}, j = {
  TIMESERIES: "timeseries",
  TOP10METHODS: "top10methods",
  TOTAL: "total",
  ACTIVITY: "activity",
  METHOD_DOMINANCE: "method_dominance",
  NETWORK_DOMINANCE: "network_dominance",
  ETH_CALL_ACTIVITY: "eth_call_activity"
}, H = {
  D: "d",
  H: "h",
  M: "m"
}, B = {
  PROJECT: "project"
}, D = {
  AUTHORIZENET: "authorizenet",
  STRIPE: "stripe"
}, F = {
  PROJECT: "project"
}, v = {
  BOGUS: "bogus",
  VISA: "visa",
  MASTER: "master",
  DISCOVER: "discover",
  AMERICAN_EXPRESS: "american_express",
  DINERS_CLUB: "diners_club",
  JCB: "jcb",
  SWITCH: "switch",
  SOLO: "solo",
  DANKORT: "dankort",
  MAESTRO: "maestro",
  LASER: "laser",
  FORBRUGSFORENINGEN: "forbrugsforeningen"
}, M = {
  FULL: "full",
  PRORATED: "prorated",
  NONE: "none"
}, G = {
  DO_NOT_RECUR: "do_not_recur",
  RECUR_INDEFINITELY: "recur_indefinitely",
  RECUR_WITH_DURATION: "recur_with_duration"
}, q = {
  COMPOUND: "compound",
  FULL_PRICE: "full-price",
  NULL: "null"
}, Q = {
  AMOUNT: "amount",
  PERCENT: "percent"
}, x = {
  COMPONENT: "Component",
  PRODUCT: "Product"
}, k = {
  DOWNGRADE: "downgrade",
  DELETE: "delete",
  CANCELLED_DOWNGRADE: "cancelled_downgrade",
  CANCELLED_DELETE: "cancelled_delete"
}, W = {
  DO_NOT_RECUR: "do_not_recur",
  RECUR_INDEFINITELY: "recur_indefinitely",
  RECUR_WITH_DURATION: "recur_with_duration"
}, f = {
  COMPOUND: "compound",
  FULL_PRICE: "full-price",
  NULL: "null"
}, K = {
  AMOUNT: "amount",
  PERCENT: "percent"
}, Y = {
  BOGUS: "bogus",
  AUTHORIZENET: "authorizenet",
  TRUST_COMMERCE: "trust_commerce",
  PAYMENT_EXPRESS: "payment_express",
  BEANSTREAM: "beanstream",
  BRAINTREE_BLUE: "braintree_blue",
  PAYPAL: "paypal",
  QUICKPAY: "quickpay",
  EWAY: "eway",
  STRIPE: "stripe",
  WIRECARD: "wirecard",
  NULL: "null"
}, $ = {
  VALIDATION: "validation",
  UNAUTHORIZED: "unauthorized",
  FORBIDDEN: "forbidden",
  UNVERIFIED: "unverified",
  INVALID_PASSWORD: "invalid_password",
  INVALID_PAYMENT: "invalid_payment",
  INVALID_MFA: "invalid_mfa",
  RATE_LIMITED: "rate_limited",
  UNKNOWN: "unknown",
  NO_RECAPTCHA: "no_recaptcha",
  OAUTH_FAIL: "oauth_fail",
  INVALID_JSON_BODY: "invalid_json_body",
  METHOD_NOT_SUPPORTED: "method_not_supported",
  EMAIL_IN_USE: "email_in_use",
  MISSING_DATA: "missing_data",
  SERVER_ERROR: "server_error",
  NOT_FOUND: "not_found",
  INVALID_DATA: "invalid_data",
  BALANCE_TOO_LOW: "balance_too_low",
  TRANSACTION_COUNT_TOO_LOW: "transaction_count_too_low",
  INVALID_EMAIL: "invalid_email",
  TOKEN_EXPIRED: "token_expired"
}, J = {
  MERGE_CHECKLIST_ACCEPTED: "MergeChecklistAccepted",
  MERGE_CHECKLIST_CANCELLED: "MergeChecklistCancelled",
  TERMS_OF_USE_ACCEPTED: "TermsOfUseAccepted",
  TERMS_OF_USE_DECLINED: "TermsOfUseDeclined"
}, X = {
  API_REQUESTS: "api-requests",
  REQUEST_PACKS: "request-packs",
  THROUGHPUT_ADDON: "throughput_addon"
}, z = {
  CORE: "core",
  DEVELOPER: "developer",
  TEAM: "team",
  GROWTH: "growth",
  CUSTOM: "custom"
}, Z = {
  CORE_FREE: "core-free"
}, ee = {
  AGREE: "agree"
}, te = {
  AUTOMATIC: "automatic",
  REMITTANCE: "remittance"
}, ae = {
  NONE: "none",
  CHILD: "child",
  PARENT: "parent"
}, re = {
  DRAFT: "draft",
  PENDING: "pending",
  OPEN: "open",
  PAID: "paid",
  VOIDED: "voided",
  CANCELED: "canceled"
}, se = {
  PROJECT: "project"
}, ne = {
  BUSINESS_SOFTWARE: "Business Software",
  CONSUMER_SOFTWARE: "Consumer Software",
  DIGITAL_SERVICES: "Digital Services",
  PHYSICAL_GOODS: "Physical Goods",
  OTHER: "Other",
  NULL: "null"
}, oe = {
  ETH_ACCOUNTS: "eth_accounts",
  ETH_BLOCK_NUMBER: "eth_blockNumber",
  ETH_CALL: "eth_call",
  ETH_CHAIN_ID: "eth_chainId",
  ETH_COMPILE_LLL: "eth_compileLLL",
  ETH_COMPILE_SERPENT: "eth_compileSerpent",
  ETH_COMPILE_SOLIDITY: "eth_compileSolidity",
  ETH_ESTIMATE_GAS: "eth_estimateGas",
  ETH_FEE_HISTORY: "eth_feeHistory",
  ETH_GAS_PRICE: "eth_gasPrice",
  ETH_GET_BALANCE: "eth_getBalance",
  ETH_GET_BLOCK_BY_HASH: "eth_getBlockByHash",
  ETH_GET_BLOCK_BY_NUMBER: "eth_getBlockByNumber",
  ETH_GET_BLOCK_RANGE: "eth_getBlockRange",
  ETH_GET_BLOCK_TRANSACTION_COUNT_BY_HASH: "eth_getBlockTransactionCountByHash",
  ETH_GET_BLOCK_TRANSACTION_COUNT_BY_NUMBER: "eth_getBlockTransactionCountByNumber",
  ETH_GET_CODE: "eth_getCode",
  ETH_GET_COMPILERS: "eth_getCompilers",
  ETH_GET_FILTER_CHANGES: "eth_getFilterChanges",
  ETH_GET_FILTER_LOGS: "eth_getFilterLogs",
  ETH_GET_LOGS: "eth_getLogs",
  ETH_GET_PROOF: "eth_getProof",
  ETH_GET_ROOT_HASH: "eth_getRootHash",
  ETH_GET_STORAGE_AT: "eth_getStorageAt",
  ETH_GET_TRANSACTION_BY_BLOCK_HASH_AND_INDEX: "eth_getTransactionByBlockHashAndIndex",
  ETH_GET_TRANSACTION_BY_BLOCK_NUMBER_AND_INDEX: "eth_getTransactionByBlockNumberAndIndex",
  ETH_GET_TRANSACTION_BY_HASH: "eth_getTransactionByHash",
  ETH_GET_TRANSACTION_COUNT: "eth_getTransactionCount",
  ETH_GET_TRANSACTION_RECEIPT: "eth_getTransactionReceipt",
  ETH_GET_UNCLE_BY_BLOCK_HASH_AND_INDEX: "eth_getUncleByBlockHashAndIndex",
  ETH_GET_UNCLE_BY_BLOCK_NUMBER_AND_INDEX: "eth_getUncleByBlockNumberAndIndex",
  ETH_GET_UNCLE_COUNT_BY_BLOCK_HASH: "eth_getUncleCountByBlockHash",
  ETH_GET_UNCLE_COUNT_BY_BLOCK_NUMBER: "eth_getUncleCountByBlockNumber",
  ETH_GET_WORK: "eth_getWork",
  ETH_HASHRATE: "eth_hashrate",
  ETH_MAX_PRIORITY_FEE_PER_GAS: "eth_maxPriorityFeePerGas",
  ETH_MINING: "eth_mining",
  ETH_NEW_BLOCK_FILTER: "eth_newBlockFilter",
  ETH_NEW_FILTER: "eth_newFilter",
  ETH_PROTOCOL_VERSION: "eth_protocolVersion",
  ETH_SEND_RAW_TRANSACTION: "eth_sendRawTransaction",
  ETH_SUBMIT_HASHRATE: "eth_submitHashrate",
  ETH_SUBMIT_WORK: "eth_submitWork",
  ETH_SUBSCRIBE: "eth_subscribe",
  ETH_UNSUBSCRIBE: "eth_unsubscribe",
  ETH_SYNCING: "eth_syncing",
  ETH_UNINSTALL_FILTER: "eth_uninstallFilter",
  BOR_GET_AUTHOR: "bor_getAuthor",
  BOR_GET_CURRENT_PROPOSER: "bor_getCurrentProposer",
  BOR_GET_CURRENT_VALIDATORS: "bor_getCurrentValidators",
  LOGS: "logs",
  NET_LISTENING: "net_listening",
  NET_PEER_COUNT: "net_peerCount",
  NET_VERSION: "net_version",
  NEW_HEADS: "newHeads",
  PARITY_NEXT_NONCE: "parity_nextNonce",
  NEW_PENDING_TRANSACTIONS: "newPendingTransactions",
  RELAY_GET_BALANCE: "relay_getBalance",
  RELAY_GET_TRANSACTION_STATUS: "relay_getTransactionStatus",
  RELAY_SEND_TRANSACTION: "relay_sendTransaction",
  TRACE_BLOCK: "trace_block",
  WEB3_CLIENT_VERSION: "web3_clientVersion",
  WEB3_SHA3: "web3_sha3",
  GET_GAS_PRICES: "get_gas_prices",
  GET_SUGGESTED_GAS_PRICES: "get_suggested_gas_prices",
  GET_BASE_FEE_PERCENTILE: "get_base_fee_percentile",
  GET_BUSY_THRESHOLD: "get_busy_threshold",
  GET_BASE_FEE_HISTORY: "get_base_fee_history"
}, le = {
  ARBITRUM: "arbitrum",
  AVALANCHE: "avalanche",
  BSC: "bsc",
  GASAPI: "gasapi",
  CELO: "celo",
  ETHEREUM: "ethereum",
  NEAR_AURORA: "nearAurora",
  NFT_API: "nftApi",
  OPTIMISM: "optimism",
  PALM: "palm",
  POLYGON: "polygon",
  STARKNET: "starknet",
  LINEA: "linea",
  BASE: "base"
}, ce = {
  MAINNET: "mainnet",
  RINKEBY: "rinkeby",
  GOERLI: "goerli",
  KOVAN: "kovan",
  POLYGON_MAINNET: "polygon-mainnet",
  POLYGON_MUMBAI: "polygon-mumbai",
  OPTIMISM_MAINNET: "optimism-mainnet",
  OPTIMISM_GOERLI: "optimism-goerli",
  ARBITRUM_MAINNET: "arbitrum-mainnet",
  ARBITRUM_GOERLI: "arbitrum-goerli",
  PALM_MAINNET: "palm-mainnet",
  PALM_TESTNET: "palm-testnet",
  PALM_DEVNET: "palm-devnet",
  NEAR_MAINNET: "near.mainnet",
  NEAR_TESTNET: "near.testnet",
  AURORA_MAINNET: "aurora-mainnet",
  AURORA_TESTNET: "aurora-testnet",
  STARKNET_MAINNET: "starknet-mainnet",
  STARKNET_GOERLI: "starknet.goerli",
  STARKNET_GOERLI2: "starknet.goerli2",
  AVALANCHE_MAINNET: "avalanche-mainnet",
  AVALANCHE_FUJI: "avalanche-fuji",
  CELO_MAINNET: "celo-mainnet",
  CELO_ALFAJORES: "celo-alfajores",
  BINANCESMARTCHAIN_MAINNET: "binancesmartchain-mainnet",
  BINANCESMARTCHAIN_TESTNET: "binancesmartchain-testnet",
  NFT_1: "nft.1",
  NFT_5: "nft.5",
  NFT_56: "nft.56",
  NFT_137: "nft.137",
  NFT_80001: "nft.80001",
  NFT_11155111: "nft.11155111",
  BASE_GOERLI: "base-goerli",
  CONSENSYS_ZKEVM_GOERLI_PREALPHA: "consensys-zkevm-goerli-prealpha",
  LINEA_GOERLI: "linea-goerli",
  BASE_MAINNET: "base-mainnet",
  LINEA_MAINNET: "linea-mainnet"
}, ie = {
  PROJECTS_DELETE: "projects.delete",
  PROJECTS_READ: "projects.read",
  PROJECTS_WRITE: "projects.write",
  USER_READ: "user.read",
  OFFLINE: "offline",
  OPENID: "openid"
}, he = {
  NFT_COLLECTIBLES: "nft/collectibles",
  TRANSACTIONS_WALLETS: "transactions/wallets",
  GAMING: "gaming",
  DEFI_FINANCIAL_PRODUCTS: "defi/financial_products",
  DAO: "dao",
  BLOCKCHAIN_L2: "blockchain/l2",
  MEDIA: "media",
  SPORTS: "sports",
  METAVERSE: "metaverse",
  INFRASTRUCTURE: "infrastructure",
  CONSULTING: "consulting"
}, de = {
  SOLO_FREELANCE: "solo/freelance",
  SMALL_STARTUP: "small_startup",
  LARGE_STARTUP: "large_startup",
  MID_MARKET: "mid_market",
  ENTERPRISE: "enterprise"
}, ue = {
  CREDIT_CARD: "credit_card",
  BANK_ACCOUNT: "bank_account"
}, pe = {
  ETHEREUM: "ethereum",
  IPFS: "ipfs"
}, Oe = {
  MONTH: "month",
  DAY: "day",
  NEVER: "never",
  NULL: "null"
}, me = {
  MONTH: "month",
  DAY: "day"
}, Ee = {
  MONTH: "month",
  DAY: "day",
  NULL: "null"
}, Ae = {
  OWNER: "owner",
  ADMIN: "admin",
  CONTRIBUTOR: "contributor"
}, Te = {
  USER_AGENTS: "user_agents",
  ORIGINS: "origins",
  ADDRESSES: "addresses",
  CONTRACTS: "contracts",
  METHODS: "methods"
}, Pe = {
  TRAFFIC_ADDON: "traffic_addon",
  THROUGHPUT_ADDON: "throughput_addon",
  ARCHIVE_ADDON: "archive_addon",
  ARBITRUM: "arbitrum",
  OPTIMISM: "optimism",
  POLYGON: "polygon"
}, Ve = {
  CORE: "core",
  DEVELOPER: "developer",
  TEAM: "team",
  GROWTH: "growth",
  ENTERPRISE: "enterprise"
}, ye = {
  MERCHANT_UI: "merchant_ui",
  MERCHANT_API: "merchant_api",
  DUNNING: "dunning",
  BILLING_PORTAL: "billing_portal",
  NULL: "null"
}, _e = {
  AUTOMATIC: "automatic",
  INVOICE: "invoice",
  REMITTANCE: "remittance",
  PREPAID: "prepaid",
  NULL: "null"
}, Ce = {
  ACTIVE: "active",
  CANCELED: "canceled",
  EXPIRED: "expired",
  ON_HOLD: "on_hold",
  PAST_DUE: "past_due",
  SOFT_FAILURE: "soft_failure",
  TRIALING: "trialing",
  TRIAL_ENDED: "trial_ended",
  UNPAID: "unpaid",
  SUSPENDED: "suspended",
  AWAITING_SIGNUP: "awaiting_signup",
  ASSESSING: "assessing",
  FAILED_TO_CREATE: "failed_to_create",
  PAUSED: "paused",
  PENDING: "pending"
}, Re = {
  COUNT: "count"
}, Se = {
  THROUGHPUT: "throughput"
}, Ue = {
  _30D: "30d"
}, be = {
  D: "d"
}, ge = {
  PUBLIC: "public",
  PRIVATE: "private"
}, Ie = {
  COUNT: "count",
  BANDWIDTH: "bandwidth"
}, Ne = {
  USAGE_VOLUME: "usage_volume",
  METHOD_USAGE: "method_usage",
  NETWORK_USAGE: "network_usage"
}, Le = {
  D: "d",
  H: "h"
}, we = {
  CUSTOM: "custom",
  HACKERONE: "hackerone",
  INTERNAL: "internal",
  CONSENSYS: "consensys"
}, je = {
  CUSTOM: "custom",
  HACKERONE: "hackerone",
  INTERNAL: "internal",
  CONSENSYS: "consensys"
}, He = {
  ENGINEER_DEVELOPER: "engineer/developer",
  IT_SYSADMIN_DEVOPS: "it/sysadmin/devops",
  MANAGER_DIRECTOR: "manager/director",
  FOUNDER_EXECUTIVE: "founder/executive"
}, b = function(o) {
  return {
    /**
     * 
     * @summary Accept Consent Challenge (oAuth Hydra)
     * @param {OAuthAcceptInput} oAuthAcceptInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptOAuthConsent: async (a, e = {}) => {
      A("acceptOAuthConsent", "oAuthAcceptInput", a);
      const r = "/oauth/consent/accept", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Accepts a Login Challenge (oAuth Hydra)
     * @param {OAuthVerifyInput} oAuthVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptOAuthLogin: async (a, e = {}) => {
      A("acceptOAuthLogin", "oAuthVerifyInput", a);
      const r = "/oauth/login/accept", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Cancels a delayed plan downgrade.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelDowngrade: async (a = {}) => {
      const e = "/customer/subscription/cancel_downgrade", r = new URL(e, p);
      let t;
      o && (t = o.baseOptions);
      const s = { method: "PUT", ...t, ...a }, n = {};
      O(r, {});
      let c = t && t.headers ? t.headers : {};
      return s.headers = { ...n, ...c, ...a.headers }, {
        url: m(r),
        options: s
      };
    },
    /**
     * 
     * @summary Changes a user\'s email and sends verification
     * @param {ChangeEmailInput} changeEmailInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeEmail: async (a, e = {}) => {
      A("changeEmail", "changeEmailInput", a);
      const r = "/change_email", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "PUT", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Changes a user\'s password
     * @param {ChangePasswordInput} changePasswordInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changePassword: async (a, e = {}) => {
      A("changePassword", "changePasswordInput", a);
      const r = "/change_password", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "PUT", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary It provides a temporary link to the portal specific to each customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCustomerPortalSession: async (a = {}) => {
      const e = "/customer/portal", r = new URL(e, p);
      let t;
      o && (t = o.baseOptions);
      const s = { method: "POST", ...t, ...a }, n = {};
      O(r, {});
      let c = t && t.headers ? t.headers : {};
      return s.headers = { ...n, ...c, ...a.headers }, {
        url: m(r),
        options: s
      };
    },
    /**
     * 
     * @summary CreateEvent logs an analytics event to Cloudwatch under the topic `infura.events.web.v1.${req.body.type}`
     * @param {Event} event 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEvent: async (a, e = {}) => {
      A("createEvent", "event", a);
      const r = "/e", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Add a new JWT public key
     * @param {string} projectId Project ID
     * @param {JWTPublicKeyInput} [jWTPublicKeyInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createJWTPublicKey: async (a, e, r = {}) => {
      A("createJWTPublicKey", "projectId", a);
      const t = "/projects/{projectId}/jwt/public_key".replace("{projectId}", encodeURIComponent(String(a))), s = new URL(t, p);
      let n;
      o && (n = o.baseOptions);
      const l = { method: "PUT", ...n, ...r }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(s, i);
      let T = n && n.headers ? n.headers : {};
      return l.headers = { ...c, ...T, ...r.headers }, l.data = P(e, l, o), {
        url: m(s),
        options: l
      };
    },
    /**
     * 
     * @summary Create a new project
     * @param {ProjectInput} [projectInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createProject: async (a, e = {}) => {
      const r = "/projects", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Create a new user
     * @param {string} [recaptcha] The recaptcha code
     * @param {string} [challenge] An oauth challenge
     * @param {CreateUserInput} [createUserInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser: async (a, e, r, t = {}) => {
      const s = "/users", n = new URL(s, p);
      let l;
      o && (l = o.baseOptions);
      const c = { method: "POST", ...l, ...t }, i = {}, T = {};
      a !== void 0 && (T.recaptcha = a), e !== void 0 && (T.challenge = e), i["Content-Type"] = "application/json", O(n, T);
      let V = l && l.headers ? l.headers : {};
      return c.headers = { ...i, ...V, ...t.headers }, c.data = P(r, c, o), {
        url: m(n),
        options: c
      };
    },
    /**
     * 
     * @summary Remove an existing JWT public key
     * @param {string} projectId Project ID
     * @param {string} keyId ID of the public key to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteJWTPublicKey: async (a, e, r = {}) => {
      A("deleteJWTPublicKey", "projectId", a), A("deleteJWTPublicKey", "keyId", e);
      const t = "/projects/{projectId}/jwt/public_key/{keyId}".replace("{projectId}", encodeURIComponent(String(a))).replace("{keyId}", encodeURIComponent(String(e))), s = new URL(t, p);
      let n;
      o && (n = o.baseOptions);
      const l = { method: "DELETE", ...n, ...r }, c = {};
      O(s, {});
      let T = n && n.headers ? n.headers : {};
      return l.headers = { ...c, ...T, ...r.headers }, {
        url: m(s),
        options: l
      };
    },
    /**
     * 
     * @summary Delete the mfa registration
     * @param {MFAVerifyInput} mFAVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteMfa: async (a, e = {}) => {
      A("deleteMfa", "mFAVerifyInput", a);
      const r = "/mfa/delete", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Delete a project
     * @param {string} projectId Project ID
     * @param {MFAVerifyInput} [mFAVerifyInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProject: async (a, e, r = {}) => {
      A("deleteProject", "projectId", a);
      const t = "/projects/{projectId}".replace("{projectId}", encodeURIComponent(String(a))), s = new URL(t, p);
      let n;
      o && (n = o.baseOptions);
      const l = { method: "DELETE", ...n, ...r }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(s, i);
      let T = n && n.headers ? n.headers : {};
      return l.headers = { ...c, ...T, ...r.headers }, l.data = P(e, l, o), {
        url: m(s),
        options: l
      };
    },
    /**
     * 
     * @summary Delete security items
     * @param {string} projectId Project ID
     * @param {SecurityType} securityType Security Type
     * @param {SecurityInput} [securityInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteSecurityItem: async (a, e, r, t = {}) => {
      A("deleteSecurityItem", "projectId", a), A("deleteSecurityItem", "securityType", e);
      const s = "/projects/{projectId}/security/{securityType}".replace("{projectId}", encodeURIComponent(String(a))).replace("{securityType}", encodeURIComponent(String(e))), n = new URL(s, p);
      let l;
      o && (l = o.baseOptions);
      const c = { method: "DELETE", ...l, ...t }, i = {}, T = {};
      i["Content-Type"] = "application/json", O(n, T);
      let V = l && l.headers ? l.headers : {};
      return c.headers = { ...i, ...V, ...t.headers }, c.data = P(r, c, o), {
        url: m(n),
        options: c
      };
    },
    /**
     * 
     * @summary Deletes a User
     * @param {string} id User ID or email
     * @param {string} [mfaVerificationCode] User MFA verification code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser: async (a, e, r = {}) => {
      A("deleteUser", "id", a);
      const t = "/users/{id}".replace("{id}", encodeURIComponent(String(a))), s = new URL(t, p);
      let n;
      o && (n = o.baseOptions);
      const l = { method: "DELETE", ...n, ...r }, c = {}, i = {};
      e !== void 0 && (i.mfaVerificationCode = e), O(s, i);
      let T = n && n.headers ? n.headers : {};
      return l.headers = { ...c, ...T, ...r.headers }, {
        url: m(s),
        options: l
      };
    },
    /**
     * 
     * @summary Delete user\'s wallet id
     * @param {string} id User ID
     * @param {UserWalletInput} userWalletInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUserWallet: async (a, e, r = {}) => {
      A("deleteUserWallet", "id", a), A("deleteUserWallet", "userWalletInput", e);
      const t = "/users/{id}/wallet".replace("{id}", encodeURIComponent(String(a))), s = new URL(t, p);
      let n;
      o && (n = o.baseOptions);
      const l = { method: "DELETE", ...n, ...r }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(s, i);
      let T = n && n.headers ? n.headers : {};
      return l.headers = { ...c, ...T, ...r.headers }, l.data = P(e, l, o), {
        url: m(s),
        options: l
      };
    },
    /**
     * 
     * @summary Enables 2FA
     * @param {MFAVerifyInput} mFAVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enableMFA: async (a, e = {}) => {
      A("enableMFA", "mFAVerifyInput", a);
      const r = "/mfa/enable", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Get a customers\' churn data
     * @param {string} id User ID
     * @param {number} [limit] response data limit
     * @param {number} [after] get data &#x60;after&#x60; specific count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllCustomerChurn: async (a, e, r, t = {}) => {
      A("getAllCustomerChurn", "id", a);
      const s = "/users/{id}/customer_churn".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, p);
      let l;
      o && (l = o.baseOptions);
      const c = { method: "GET", ...l, ...t }, i = {}, T = {};
      e !== void 0 && (T.limit = e), r !== void 0 && (T.after = r), O(n, T);
      let V = l && l.headers ? l.headers : {};
      return c.headers = { ...i, ...V, ...t.headers }, {
        url: m(n),
        options: c
      };
    },
    /**
     * 
     * @summary GetAnalytics
     * @param {AnalyticsInput} analyticsInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAnalytics: async (a, e = {}) => {
      A("getAnalytics", "analyticsInput", a);
      const r = "/stats", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * Get blog posts from www.infura.io/blog, passing query params into the ghost posts api.
     * @summary Get the blog posts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBlogPosts: async (a = {}) => {
      const e = "/posts", r = new URL(e, p);
      let t;
      o && (t = o.baseOptions);
      const s = { method: "GET", ...t, ...a }, n = {};
      O(r, {});
      let c = t && t.headers ? t.headers : {};
      return s.headers = { ...n, ...c, ...a.headers }, {
        url: m(r),
        options: s
      };
    },
    /**
     * 
     * @summary returns user\'s payment profile (credit-card) from chargify
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getChargifyCard: async (a = {}) => {
      const e = "/cards", r = new URL(e, p);
      let t;
      o && (t = o.baseOptions);
      const s = { method: "GET", ...t, ...a }, n = {};
      O(r, {});
      let c = t && t.headers ? t.headers : {};
      return s.headers = { ...n, ...c, ...a.headers }, {
        url: m(r),
        options: s
      };
    },
    /**
     * 
     * @summary Get coupon
     * @param {string} promoCode The promocode to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCoupon: async (a, e = {}) => {
      A("getCoupon", "promoCode", a);
      const r = "/coupons/{promoCode}".replace("{promoCode}", encodeURIComponent(String(a))), t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "GET", ...s, ...e }, l = {};
      O(t, {});
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Retrieves the details of an existing chargify customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomer: async (a = {}) => {
      const e = "/customer", r = new URL(e, p);
      let t;
      o && (t = o.baseOptions);
      const s = { method: "GET", ...t, ...a }, n = {};
      O(r, {});
      let c = t && t.headers ? t.headers : {};
      return s.headers = { ...n, ...c, ...a.headers }, {
        url: m(r),
        options: s
      };
    },
    /**
     * 
     * @summary Get a customer\'s segmentation data
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerSegmentation: async (a, e = {}) => {
      A("getCustomerSegmentation", "id", a);
      const r = "/users/{id}/customer_segmentation".replace("{id}", encodeURIComponent(String(a))), t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "GET", ...s, ...e }, l = {};
      O(t, {});
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary GetEthCallActivityStats
     * @param {AnalyticsQuery} analyticsQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEthCallActivityStats: async (a, e = {}) => {
      A("getEthCallActivityStats", "analyticsQuery", a);
      const r = "/stats/eth_call_activity", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Gets users\' chargify invoices
     * @param {number} [page] 
     * @param {number} [perPage] 
     * @param {Product} [product] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoices: async (a, e, r, t = {}) => {
      const s = "/invoices", n = new URL(s, p);
      let l;
      o && (l = o.baseOptions);
      const c = { method: "GET", ...l, ...t }, i = {}, T = {};
      a !== void 0 && (T.page = a), e !== void 0 && (T.perPage = e), r !== void 0 && (T.product = r), O(n, T);
      let V = l && l.headers ? l.headers : {};
      return c.headers = { ...i, ...V, ...t.headers }, {
        url: m(n),
        options: c
      };
    },
    /**
     * 
     * @summary Gets a user identified by Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMe: async (a = {}) => {
      const e = "/me", r = new URL(e, p);
      let t;
      o && (t = o.baseOptions);
      const s = { method: "GET", ...t, ...a }, n = {};
      O(r, {});
      let c = t && t.headers ? t.headers : {};
      return s.headers = { ...n, ...c, ...a.headers }, {
        url: m(r),
        options: s
      };
    },
    /**
     * 
     * @summary GetMethodDominanceStats
     * @param {AnalyticsQuery} analyticsQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMethodDominanceStats: async (a, e = {}) => {
      A("getMethodDominanceStats", "analyticsQuery", a);
      const r = "/stats/method-dominance", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary GetNetworkDominanceStats
     * @param {AnalyticsQuery} analyticsQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNetworkDominanceStats: async (a, e = {}) => {
      A("getNetworkDominanceStats", "analyticsQuery", a);
      const r = "/stats/network-dominance", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Get the networks that the user has access to for this project
     * @param {string} projectId Project ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNetworks: async (a, e = {}) => {
      A("getNetworks", "projectId", a);
      const r = "/projects/{projectId}/networks".replace("{projectId}", encodeURIComponent(String(a))), t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "GET", ...s, ...e }, l = {};
      O(t, {});
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Gets tier and addon offerings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOfferings: async (a = {}) => {
      const e = "/offerings", r = new URL(e, p);
      let t;
      o && (t = o.baseOptions);
      const s = { method: "GET", ...t, ...a }, n = {};
      O(r, {});
      let c = t && t.headers ? t.headers : {};
      return s.headers = { ...n, ...c, ...a.headers }, {
        url: m(r),
        options: s
      };
    },
    /**
     * 
     * @summary Get a project
     * @param {string} projectId Project ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProject: async (a, e = {}) => {
      A("getProject", "projectId", a);
      const r = "/projects/{projectId}".replace("{projectId}", encodeURIComponent(String(a))), t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "GET", ...s, ...e }, l = {};
      O(t, {});
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary GetRequestActivityStats
     * @param {AnalyticsQuery} analyticsQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRequestActivityStats: async (a, e = {}) => {
      A("getRequestActivityStats", "analyticsQuery", a);
      const r = "/stats/request-activity", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary GetRequestVolumeStats
     * @param {AnalyticsQuery} analyticsQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRequestVolumeStats: async (a, e = {}) => {
      A("getRequestVolumeStats", "analyticsQuery", a);
      const r = "/stats/request_volume", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Gets users\' stripe invoices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStripeInvoices: async (a = {}) => {
      const e = "/invoices/stripe", r = new URL(e, p);
      let t;
      o && (t = o.baseOptions);
      const s = { method: "GET", ...t, ...a }, n = {};
      O(r, {});
      let c = t && t.headers ? t.headers : {};
      return s.headers = { ...n, ...c, ...a.headers }, {
        url: m(r),
        options: s
      };
    },
    /**
     * 
     * @summary Retrieves a user\'s Chargify subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscription: async (a = {}) => {
      const e = "/customer/subscription", r = new URL(e, p);
      let t;
      o && (t = o.baseOptions);
      const s = { method: "GET", ...t, ...a }, n = {};
      O(r, {});
      let c = t && t.headers ? t.headers : {};
      return s.headers = { ...n, ...c, ...a.headers }, {
        url: m(r),
        options: s
      };
    },
    /**
     * The number of credits that can be used per second, ensuring consistent performance.
     * @summary GetThroughput
     * @param {ThroughputQuery} throughputQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getThroughput: async (a, e = {}) => {
      A("getThroughput", "throughputQuery", a);
      const r = "/usage/usage-tracker", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * Get the total credit usage per method | key | network depending on query
     * @summary GetTotalUsage
     * @param {UsageQuery} usageQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTotalUsage: async (a, e = {}) => {
      A("getTotalUsage", "usageQuery", a);
      const r = "/usage/total-usage", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * Returns a single user
     * @summary Find user by ID
     * @param {string} id User
     * @param {boolean} check Whether or not to check if a user with given email exists
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser: async (a, e, r = {}) => {
      A("getUser", "id", a), A("getUser", "check", e);
      const t = "/users/{id}".replace("{id}", encodeURIComponent(String(a))), s = new URL(t, p);
      let n;
      o && (n = o.baseOptions);
      const l = { method: "GET", ...n, ...r }, c = {}, i = {};
      e !== void 0 && (i.check = e), O(s, i);
      let T = n && n.headers ? n.headers : {};
      return l.headers = { ...c, ...T, ...r.headers }, {
        url: m(s),
        options: l
      };
    },
    /**
     * 
     * @summary Get user\'s wallet ids
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserWallets: async (a, e = {}) => {
      A("getUserWallets", "id", a);
      const r = "/users/{id}/wallets".replace("{id}", encodeURIComponent(String(a))), t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "GET", ...s, ...e }, l = {};
      O(t, {});
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Link 2FA
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    linkMFA: async (a = {}) => {
      const e = "/mfa/link", r = new URL(e, p);
      let t;
      o && (t = o.baseOptions);
      const s = { method: "GET", ...t, ...a }, n = {};
      O(r, {});
      let c = t && t.headers ? t.headers : {};
      return s.headers = { ...n, ...c, ...a.headers }, {
        url: m(r),
        options: s
      };
    },
    /**
     * 
     * @summary Lists all projects
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listProjects: async (a = {}) => {
      const e = "/projects", r = new URL(e, p);
      let t;
      o && (t = o.baseOptions);
      const s = { method: "GET", ...t, ...a }, n = {};
      O(r, {});
      let c = t && t.headers ? t.headers : {};
      return s.headers = { ...n, ...c, ...a.headers }, {
        url: m(r),
        options: s
      };
    },
    /**
     * 
     * @summary Retrieves the request packs compnonent allocation to a user\'s Chargify subscription. Subscription components usually represent addons.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listRequestPackAllocations: async (a = {}) => {
      const e = "/customer/subscription/list_component_allocations/request_packs", r = new URL(e, p);
      let t;
      o && (t = o.baseOptions);
      const s = { method: "GET", ...t, ...a }, n = {};
      O(r, {});
      let c = t && t.headers ? t.headers : {};
      return s.headers = { ...n, ...c, ...a.headers }, {
        url: m(r),
        options: s
      };
    },
    /**
     * 
     * @summary Retrieves all Chargify subscriptions for a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listSubscriptions: async (a = {}) => {
      const e = "/customer/list_subscriptions", r = new URL(e, p);
      let t;
      o && (t = o.baseOptions);
      const s = { method: "GET", ...t, ...a }, n = {};
      O(r, {});
      let c = t && t.headers ? t.headers : {};
      return s.headers = { ...n, ...c, ...a.headers }, {
        url: m(r),
        options: s
      };
    },
    /**
     * 
     * @summary Logs in a user
     * @param {LoginInput} loginInput 
     * @param {string} [challenge] An oauth challenge
     * @param {string} [recaptcha] The recaptcha code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login: async (a, e, r, t = {}) => {
      A("login", "loginInput", a);
      const s = "/login", n = new URL(s, p);
      let l;
      o && (l = o.baseOptions);
      const c = { method: "POST", ...l, ...t }, i = {}, T = {};
      e !== void 0 && (T.challenge = e), r !== void 0 && (T.recaptcha = r), i["Content-Type"] = "application/json", O(n, T);
      let V = l && l.headers ? l.headers : {};
      return c.headers = { ...i, ...V, ...t.headers }, c.data = P(a, c, o), {
        url: m(n),
        options: c
      };
    },
    /**
     * 
     * @summary Logs out a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout: async (a = {}) => {
      const e = "/logout", r = new URL(e, p);
      let t;
      o && (t = o.baseOptions);
      const s = { method: "GET", ...t, ...a }, n = {};
      O(r, {});
      let c = t && t.headers ? t.headers : {};
      return s.headers = { ...n, ...c, ...a.headers }, {
        url: m(r),
        options: s
      };
    },
    /**
     * 
     * @summary Preview Chargify Subscription
     * @param {PreviewSubscriptionRequest} previewSubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    previewSubscription: async (a, e = {}) => {
      A("previewSubscription", "previewSubscriptionRequest", a);
      const r = "/customer/subscription/preview", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Creates support ticket for customers\' 2FA-enabled accounts with no backup code.
     * @param {RecoverMFAInput} recoverMFAInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recoverMFA: async (a, e = {}) => {
      A("recoverMFA", "recoverMFAInput", a);
      const r = "/mfa/recover", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Reject Consent Challenge (oAuth Hydra)
     * @param {OAuthVerifyInput} oAuthVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rejectOAuthConsent: async (a, e = {}) => {
      A("rejectOAuthConsent", "oAuthVerifyInput", a);
      const r = "/oauth/consent/reject", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Delete pinned object(s)
     * @param {string} projectId IPFS project ID
     * @param {Array<string>} arg Paths to objects(s) to be unpinned.
     * @param {string} projectSecret The project secret
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removePins: async (a, e, r, t = {}) => {
      A("removePins", "projectId", a), A("removePins", "arg", e), A("removePins", "projectSecret", r);
      const s = "/ipfs/projects/{projectId}/pins".replace("{projectId}", encodeURIComponent(String(a))), n = new URL(s, p);
      let l;
      o && (l = o.baseOptions);
      const c = { method: "DELETE", ...l, ...t }, i = {}, T = {};
      e && (T.arg = e), r != null && (i["project-secret"] = String(r)), O(n, T);
      let V = l && l.headers ? l.headers : {};
      return c.headers = { ...i, ...V, ...t.headers }, {
        url: m(n),
        options: c
      };
    },
    /**
     * 
     * @summary Resends an verification link for updating email
     * @param {EmptyMessage} [emptyMessage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendUpdateEmail: async (a, e = {}) => {
      const r = "/resend_update_email", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Resends an account verification email
     * @param {EmptyMessage} [emptyMessage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendVerification: async (a, e = {}) => {
      const r = "/resend_verification", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Check MFA Registration
     * @param {MFAResetInput} mFAResetInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetMFA: async (a, e = {}) => {
      A("resetMFA", "mFAResetInput", a);
      const r = "/mfa/reset", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Resets a user\'s password after sending forgot email
     * @param {ResetPasswordInput} resetPasswordInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword: async (a, e = {}) => {
      A("resetPassword", "resetPasswordInput", a);
      const r = "/reset_password", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Retries a canceled Chargify subscription
     * @param {RetrySubscriptionRequest} retrySubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrySubscription: async (a, e = {}) => {
      A("retrySubscription", "retrySubscriptionRequest", a);
      const r = "/customer/subscription/retry", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Send first request
     * @param {CustomerOnboardingFirstRequestInput} customerOnboardingFirstRequestInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendFirstRequest: async (a, e = {}) => {
      A("sendFirstRequest", "customerOnboardingFirstRequestInput", a);
      const r = "/customer_onboarding/send_request", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Sends a reset password email
     * @param {SendResetPasswordInput} sendResetPasswordInput 
     * @param {string} [recaptcha] The recaptcha code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendForgotEmail: async (a, e, r = {}) => {
      A("sendForgotEmail", "sendResetPasswordInput", a);
      const t = "/forgot_email", s = new URL(t, p);
      let n;
      o && (n = o.baseOptions);
      const l = { method: "POST", ...n, ...r }, c = {}, i = {};
      e !== void 0 && (i.recaptcha = e), c["Content-Type"] = "application/json", O(s, i);
      let T = n && n.headers ? n.headers : {};
      return l.headers = { ...c, ...T, ...r.headers }, l.data = P(a, l, o), {
        url: m(s),
        options: l
      };
    },
    /**
     * 
     * @summary Remove the servo addon from the user\'s service plan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uksAddonServoDelete: async (a = {}) => {
      const e = "/uks/addon/servo", r = new URL(e, p);
      let t;
      o && (t = o.baseOptions);
      const s = { method: "DELETE", ...t, ...a }, n = {};
      O(r, {});
      let c = t && t.headers ? t.headers : {};
      return s.headers = { ...n, ...c, ...a.headers }, {
        url: m(r),
        options: s
      };
    },
    /**
     * 
     * @summary Add the servo addon to the user\'s service plan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uksAddonServoPut: async (a = {}) => {
      const e = "/uks/addon/servo", r = new URL(e, p);
      let t;
      o && (t = o.baseOptions);
      const s = { method: "PUT", ...t, ...a }, n = {};
      O(r, {});
      let c = t && t.headers ? t.headers : {};
      return s.headers = { ...n, ...c, ...a.headers }, {
        url: m(r),
        options: s
      };
    },
    /**
     * 
     * @summary Updates card billing info
     * @param {CardBillingInfoInput} cardBillingInfoInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCardBillingInfo: async (a, e = {}) => {
      A("updateCardBillingInfo", "cardBillingInfoInput", a);
      const r = "/cards/billing_info", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "PUT", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Updates the details of an existing chargify customer
     * @param {UpdateCustomerInput} updateCustomerInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCustomer: async (a, e = {}) => {
      A("updateCustomer", "updateCustomerInput", a);
      const r = "/customer", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "PUT", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Update customers\' discord
     * @param {string} id User ID
     * @param {CustomerDiscordInput} customerDiscordInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCustomerDiscord: async (a, e, r = {}) => {
      A("updateCustomerDiscord", "id", a), A("updateCustomerDiscord", "customerDiscordInput", e);
      const t = "/users/{id}/customer_discord".replace("{id}", encodeURIComponent(String(a))), s = new URL(t, p);
      let n;
      o && (n = o.baseOptions);
      const l = { method: "PUT", ...n, ...r }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(s, i);
      let T = n && n.headers ? n.headers : {};
      return l.headers = { ...c, ...T, ...r.headers }, l.data = P(e, l, o), {
        url: m(s),
        options: l
      };
    },
    /**
     * 
     * @summary Update customers\' onboarding
     * @param {string} id User ID
     * @param {CustomerOnboardingInput} customerOnboardingInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCustomerOnboarding: async (a, e, r = {}) => {
      A("updateCustomerOnboarding", "id", a), A("updateCustomerOnboarding", "customerOnboardingInput", e);
      const t = "/users/{id}/customer_onboarding".replace("{id}", encodeURIComponent(String(a))), s = new URL(t, p);
      let n;
      o && (n = o.baseOptions);
      const l = { method: "PUT", ...n, ...r }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(s, i);
      let T = n && n.headers ? n.headers : {};
      return l.headers = { ...c, ...T, ...r.headers }, l.data = P(e, l, o), {
        url: m(s),
        options: l
      };
    },
    /**
     * 
     * @summary Updates a customer\'s segmentation data
     * @param {string} id User ID
     * @param {CustomerSegmentation} customerSegmentation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCustomerSegmentation: async (a, e, r = {}) => {
      A("updateCustomerSegmentation", "id", a), A("updateCustomerSegmentation", "customerSegmentation", e);
      const t = "/users/{id}/customer_segmentation".replace("{id}", encodeURIComponent(String(a))), s = new URL(t, p);
      let n;
      o && (n = o.baseOptions);
      const l = { method: "PUT", ...n, ...r }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(s, i);
      let T = n && n.headers ? n.headers : {};
      return l.headers = { ...c, ...T, ...r.headers }, l.data = P(e, l, o), {
        url: m(s),
        options: l
      };
    },
    /**
     * 
     * @summary Creates or Updates a customers\' churn
     * @param {string} id User ID
     * @param {CustomerChurnInput} customerChurnInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrCreateCustomerChurn: async (a, e, r = {}) => {
      A("updateOrCreateCustomerChurn", "id", a), A("updateOrCreateCustomerChurn", "customerChurnInput", e);
      const t = "/users/{id}/customer_churn".replace("{id}", encodeURIComponent(String(a))), s = new URL(t, p);
      let n;
      o && (n = o.baseOptions);
      const l = { method: "POST", ...n, ...r }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(s, i);
      let T = n && n.headers ? n.headers : {};
      return l.headers = { ...c, ...T, ...r.headers }, l.data = P(e, l, o), {
        url: m(s),
        options: l
      };
    },
    /**
     * 
     * @summary Update a project
     * @param {string} projectId Project ID
     * @param {ProjectInput} [projectInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProject: async (a, e, r = {}) => {
      A("updateProject", "projectId", a);
      const t = "/projects/{projectId}".replace("{projectId}", encodeURIComponent(String(a))), s = new URL(t, p);
      let n;
      o && (n = o.baseOptions);
      const l = { method: "PUT", ...n, ...r }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(s, i);
      let T = n && n.headers ? n.headers : {};
      return l.headers = { ...c, ...T, ...r.headers }, l.data = P(e, l, o), {
        url: m(s),
        options: l
      };
    },
    /**
     * 
     * @summary Create or update security items
     * @param {string} projectId Project ID
     * @param {SecurityType} securityType Security Type
     * @param {SecurityInput} [securityInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSecurityItem: async (a, e, r, t = {}) => {
      A("updateSecurityItem", "projectId", a), A("updateSecurityItem", "securityType", e);
      const s = "/projects/{projectId}/security/{securityType}".replace("{projectId}", encodeURIComponent(String(a))).replace("{securityType}", encodeURIComponent(String(e))), n = new URL(s, p);
      let l;
      o && (l = o.baseOptions);
      const c = { method: "PUT", ...l, ...t }, i = {}, T = {};
      i["Content-Type"] = "application/json", O(n, T);
      let V = l && l.headers ? l.headers : {};
      return c.headers = { ...i, ...V, ...t.headers }, c.data = P(r, c, o), {
        url: m(n),
        options: c
      };
    },
    /**
     * 
     * @summary Updates a user\'s service plan
     * @param {string} id User ID or email
     * @param {string} [promoCode] The promocode to apply
     * @param {ServicePlanInput} [servicePlanInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateServicePlan: async (a, e, r, t = {}) => {
      A("updateServicePlan", "id", a);
      const s = "/users/{id}/service_plan".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, p);
      let l;
      o && (l = o.baseOptions);
      const c = { method: "PUT", ...l, ...t }, i = {}, T = {};
      e !== void 0 && (T.promoCode = e), i["Content-Type"] = "application/json", O(n, T);
      let V = l && l.headers ? l.headers : {};
      return c.headers = { ...i, ...V, ...t.headers }, c.data = P(r, c, o), {
        url: m(n),
        options: c
      };
    },
    /**
     * Flatly updates updated user properties.
     * @summary Updates an existing user
     * @param {string} id User ID or email
     * @param {UserInput} [userInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser: async (a, e, r = {}) => {
      A("updateUser", "id", a);
      const t = "/users/{id}".replace("{id}", encodeURIComponent(String(a))), s = new URL(t, p);
      let n;
      o && (n = o.baseOptions);
      const l = { method: "PUT", ...n, ...r }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(s, i);
      let T = n && n.headers ? n.headers : {};
      return l.headers = { ...c, ...T, ...r.headers }, l.data = P(e, l, o), {
        url: m(s),
        options: l
      };
    },
    /**
     * 
     * @summary Updates a card
     * @param {SaveCardInput} saveCardInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertCard: async (a, e = {}) => {
      A("upsertCard", "saveCardInput", a);
      const r = "/cards", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "PUT", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Update user\'s wallet id
     * @param {string} id User ID
     * @param {UserWalletInput} userWalletInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertUserWallet: async (a, e, r = {}) => {
      A("upsertUserWallet", "id", a), A("upsertUserWallet", "userWalletInput", e);
      const t = "/users/{id}/wallet".replace("{id}", encodeURIComponent(String(a))), s = new URL(t, p);
      let n;
      o && (n = o.baseOptions);
      const l = { method: "PUT", ...n, ...r }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(s, i);
      let T = n && n.headers ? n.headers : {};
      return l.headers = { ...c, ...T, ...r.headers }, l.data = P(e, l, o), {
        url: m(s),
        options: l
      };
    },
    /**
     * 
     * @summary Check MFA Registration
     * @param {MFAVerifyInput} mFAVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyMFA: async (a, e = {}) => {
      A("verifyMFA", "mFAVerifyInput", a);
      const r = "/mfa/verify", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Check Consent Challenge (oAuth Hydra)
     * @param {OAuthVerifyInput} oAuthVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyOAuthConsent: async (a, e = {}) => {
      A("verifyOAuthConsent", "oAuthVerifyInput", a);
      const r = "/oauth/consent/verify", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Check Login Challenge (oAuth Hydra)
     * @param {OAuthVerifyInput} oAuthVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyOAuthLogin: async (a, e = {}) => {
      A("verifyOAuthLogin", "oAuthVerifyInput", a);
      const r = "/oauth/login/verify", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Verifies a user\'s token
     * @param {VerifyInput} verifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyUser: async (a, e = {}) => {
      A("verifyUser", "verifyInput", a);
      const r = "/verify", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    },
    /**
     * 
     * @summary Logs in a user with wallet
     * @param {WalletLoginInput} walletLoginInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletLogin: async (a, e = {}) => {
      A("walletLogin", "walletLoginInput", a);
      const r = "/wallet/login", t = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const n = { method: "POST", ...s, ...e }, l = {}, c = {};
      l["Content-Type"] = "application/json", O(t, c);
      let i = s && s.headers ? s.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, n.data = P(a, n, o), {
        url: m(t),
        options: n
      };
    }
  };
}, u = function(o) {
  const a = b(o);
  return {
    /**
     * 
     * @summary Accept Consent Challenge (oAuth Hydra)
     * @param {OAuthAcceptInput} oAuthAcceptInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async acceptOAuthConsent(e, r) {
      const t = await a.acceptOAuthConsent(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Accepts a Login Challenge (oAuth Hydra)
     * @param {OAuthVerifyInput} oAuthVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async acceptOAuthLogin(e, r) {
      const t = await a.acceptOAuthLogin(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Cancels a delayed plan downgrade.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancelDowngrade(e) {
      const r = await a.cancelDowngrade(e);
      return E(r, h, d, o);
    },
    /**
     * 
     * @summary Changes a user\'s email and sends verification
     * @param {ChangeEmailInput} changeEmailInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async changeEmail(e, r) {
      const t = await a.changeEmail(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Changes a user\'s password
     * @param {ChangePasswordInput} changePasswordInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async changePassword(e, r) {
      const t = await a.changePassword(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary It provides a temporary link to the portal specific to each customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createCustomerPortalSession(e) {
      const r = await a.createCustomerPortalSession(e);
      return E(r, h, d, o);
    },
    /**
     * 
     * @summary CreateEvent logs an analytics event to Cloudwatch under the topic `infura.events.web.v1.${req.body.type}`
     * @param {Event} event 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createEvent(e, r) {
      const t = await a.createEvent(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Add a new JWT public key
     * @param {string} projectId Project ID
     * @param {JWTPublicKeyInput} [jWTPublicKeyInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createJWTPublicKey(e, r, t) {
      const s = await a.createJWTPublicKey(e, r, t);
      return E(s, h, d, o);
    },
    /**
     * 
     * @summary Create a new project
     * @param {ProjectInput} [projectInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createProject(e, r) {
      const t = await a.createProject(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Create a new user
     * @param {string} [recaptcha] The recaptcha code
     * @param {string} [challenge] An oauth challenge
     * @param {CreateUserInput} [createUserInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createUser(e, r, t, s) {
      const n = await a.createUser(e, r, t, s);
      return E(n, h, d, o);
    },
    /**
     * 
     * @summary Remove an existing JWT public key
     * @param {string} projectId Project ID
     * @param {string} keyId ID of the public key to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteJWTPublicKey(e, r, t) {
      const s = await a.deleteJWTPublicKey(e, r, t);
      return E(s, h, d, o);
    },
    /**
     * 
     * @summary Delete the mfa registration
     * @param {MFAVerifyInput} mFAVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteMfa(e, r) {
      const t = await a.deleteMfa(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Delete a project
     * @param {string} projectId Project ID
     * @param {MFAVerifyInput} [mFAVerifyInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteProject(e, r, t) {
      const s = await a.deleteProject(e, r, t);
      return E(s, h, d, o);
    },
    /**
     * 
     * @summary Delete security items
     * @param {string} projectId Project ID
     * @param {SecurityType} securityType Security Type
     * @param {SecurityInput} [securityInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteSecurityItem(e, r, t, s) {
      const n = await a.deleteSecurityItem(e, r, t, s);
      return E(n, h, d, o);
    },
    /**
     * 
     * @summary Deletes a User
     * @param {string} id User ID or email
     * @param {string} [mfaVerificationCode] User MFA verification code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteUser(e, r, t) {
      const s = await a.deleteUser(e, r, t);
      return E(s, h, d, o);
    },
    /**
     * 
     * @summary Delete user\'s wallet id
     * @param {string} id User ID
     * @param {UserWalletInput} userWalletInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteUserWallet(e, r, t) {
      const s = await a.deleteUserWallet(e, r, t);
      return E(s, h, d, o);
    },
    /**
     * 
     * @summary Enables 2FA
     * @param {MFAVerifyInput} mFAVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async enableMFA(e, r) {
      const t = await a.enableMFA(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Get a customers\' churn data
     * @param {string} id User ID
     * @param {number} [limit] response data limit
     * @param {number} [after] get data &#x60;after&#x60; specific count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAllCustomerChurn(e, r, t, s) {
      const n = await a.getAllCustomerChurn(e, r, t, s);
      return E(n, h, d, o);
    },
    /**
     * 
     * @summary GetAnalytics
     * @param {AnalyticsInput} analyticsInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAnalytics(e, r) {
      const t = await a.getAnalytics(e, r);
      return E(t, h, d, o);
    },
    /**
     * Get blog posts from www.infura.io/blog, passing query params into the ghost posts api.
     * @summary Get the blog posts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBlogPosts(e) {
      const r = await a.getBlogPosts(e);
      return E(r, h, d, o);
    },
    /**
     * 
     * @summary returns user\'s payment profile (credit-card) from chargify
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getChargifyCard(e) {
      const r = await a.getChargifyCard(e);
      return E(r, h, d, o);
    },
    /**
     * 
     * @summary Get coupon
     * @param {string} promoCode The promocode to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCoupon(e, r) {
      const t = await a.getCoupon(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Retrieves the details of an existing chargify customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCustomer(e) {
      const r = await a.getCustomer(e);
      return E(r, h, d, o);
    },
    /**
     * 
     * @summary Get a customer\'s segmentation data
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCustomerSegmentation(e, r) {
      const t = await a.getCustomerSegmentation(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary GetEthCallActivityStats
     * @param {AnalyticsQuery} analyticsQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEthCallActivityStats(e, r) {
      const t = await a.getEthCallActivityStats(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Gets users\' chargify invoices
     * @param {number} [page] 
     * @param {number} [perPage] 
     * @param {Product} [product] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInvoices(e, r, t, s) {
      const n = await a.getInvoices(e, r, t, s);
      return E(n, h, d, o);
    },
    /**
     * 
     * @summary Gets a user identified by Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMe(e) {
      const r = await a.getMe(e);
      return E(r, h, d, o);
    },
    /**
     * 
     * @summary GetMethodDominanceStats
     * @param {AnalyticsQuery} analyticsQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMethodDominanceStats(e, r) {
      const t = await a.getMethodDominanceStats(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary GetNetworkDominanceStats
     * @param {AnalyticsQuery} analyticsQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getNetworkDominanceStats(e, r) {
      const t = await a.getNetworkDominanceStats(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Get the networks that the user has access to for this project
     * @param {string} projectId Project ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getNetworks(e, r) {
      const t = await a.getNetworks(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Gets tier and addon offerings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOfferings(e) {
      const r = await a.getOfferings(e);
      return E(r, h, d, o);
    },
    /**
     * 
     * @summary Get a project
     * @param {string} projectId Project ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProject(e, r) {
      const t = await a.getProject(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary GetRequestActivityStats
     * @param {AnalyticsQuery} analyticsQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRequestActivityStats(e, r) {
      const t = await a.getRequestActivityStats(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary GetRequestVolumeStats
     * @param {AnalyticsQuery} analyticsQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRequestVolumeStats(e, r) {
      const t = await a.getRequestVolumeStats(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Gets users\' stripe invoices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getStripeInvoices(e) {
      const r = await a.getStripeInvoices(e);
      return E(r, h, d, o);
    },
    /**
     * 
     * @summary Retrieves a user\'s Chargify subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSubscription(e) {
      const r = await a.getSubscription(e);
      return E(r, h, d, o);
    },
    /**
     * The number of credits that can be used per second, ensuring consistent performance.
     * @summary GetThroughput
     * @param {ThroughputQuery} throughputQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getThroughput(e, r) {
      const t = await a.getThroughput(e, r);
      return E(t, h, d, o);
    },
    /**
     * Get the total credit usage per method | key | network depending on query
     * @summary GetTotalUsage
     * @param {UsageQuery} usageQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTotalUsage(e, r) {
      const t = await a.getTotalUsage(e, r);
      return E(t, h, d, o);
    },
    /**
     * Returns a single user
     * @summary Find user by ID
     * @param {string} id User
     * @param {boolean} check Whether or not to check if a user with given email exists
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUser(e, r, t) {
      const s = await a.getUser(e, r, t);
      return E(s, h, d, o);
    },
    /**
     * 
     * @summary Get user\'s wallet ids
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUserWallets(e, r) {
      const t = await a.getUserWallets(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Link 2FA
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async linkMFA(e) {
      const r = await a.linkMFA(e);
      return E(r, h, d, o);
    },
    /**
     * 
     * @summary Lists all projects
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listProjects(e) {
      const r = await a.listProjects(e);
      return E(r, h, d, o);
    },
    /**
     * 
     * @summary Retrieves the request packs compnonent allocation to a user\'s Chargify subscription. Subscription components usually represent addons.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listRequestPackAllocations(e) {
      const r = await a.listRequestPackAllocations(e);
      return E(r, h, d, o);
    },
    /**
     * 
     * @summary Retrieves all Chargify subscriptions for a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listSubscriptions(e) {
      const r = await a.listSubscriptions(e);
      return E(r, h, d, o);
    },
    /**
     * 
     * @summary Logs in a user
     * @param {LoginInput} loginInput 
     * @param {string} [challenge] An oauth challenge
     * @param {string} [recaptcha] The recaptcha code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async login(e, r, t, s) {
      const n = await a.login(e, r, t, s);
      return E(n, h, d, o);
    },
    /**
     * 
     * @summary Logs out a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async logout(e) {
      const r = await a.logout(e);
      return E(r, h, d, o);
    },
    /**
     * 
     * @summary Preview Chargify Subscription
     * @param {PreviewSubscriptionRequest} previewSubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async previewSubscription(e, r) {
      const t = await a.previewSubscription(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Creates support ticket for customers\' 2FA-enabled accounts with no backup code.
     * @param {RecoverMFAInput} recoverMFAInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async recoverMFA(e, r) {
      const t = await a.recoverMFA(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Reject Consent Challenge (oAuth Hydra)
     * @param {OAuthVerifyInput} oAuthVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rejectOAuthConsent(e, r) {
      const t = await a.rejectOAuthConsent(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Delete pinned object(s)
     * @param {string} projectId IPFS project ID
     * @param {Array<string>} arg Paths to objects(s) to be unpinned.
     * @param {string} projectSecret The project secret
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removePins(e, r, t, s) {
      const n = await a.removePins(e, r, t, s);
      return E(n, h, d, o);
    },
    /**
     * 
     * @summary Resends an verification link for updating email
     * @param {EmptyMessage} [emptyMessage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resendUpdateEmail(e, r) {
      const t = await a.resendUpdateEmail(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Resends an account verification email
     * @param {EmptyMessage} [emptyMessage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resendVerification(e, r) {
      const t = await a.resendVerification(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Check MFA Registration
     * @param {MFAResetInput} mFAResetInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resetMFA(e, r) {
      const t = await a.resetMFA(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Resets a user\'s password after sending forgot email
     * @param {ResetPasswordInput} resetPasswordInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resetPassword(e, r) {
      const t = await a.resetPassword(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Retries a canceled Chargify subscription
     * @param {RetrySubscriptionRequest} retrySubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async retrySubscription(e, r) {
      const t = await a.retrySubscription(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Send first request
     * @param {CustomerOnboardingFirstRequestInput} customerOnboardingFirstRequestInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendFirstRequest(e, r) {
      const t = await a.sendFirstRequest(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Sends a reset password email
     * @param {SendResetPasswordInput} sendResetPasswordInput 
     * @param {string} [recaptcha] The recaptcha code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendForgotEmail(e, r, t) {
      const s = await a.sendForgotEmail(e, r, t);
      return E(s, h, d, o);
    },
    /**
     * 
     * @summary Remove the servo addon from the user\'s service plan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uksAddonServoDelete(e) {
      const r = await a.uksAddonServoDelete(e);
      return E(r, h, d, o);
    },
    /**
     * 
     * @summary Add the servo addon to the user\'s service plan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uksAddonServoPut(e) {
      const r = await a.uksAddonServoPut(e);
      return E(r, h, d, o);
    },
    /**
     * 
     * @summary Updates card billing info
     * @param {CardBillingInfoInput} cardBillingInfoInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateCardBillingInfo(e, r) {
      const t = await a.updateCardBillingInfo(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Updates the details of an existing chargify customer
     * @param {UpdateCustomerInput} updateCustomerInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateCustomer(e, r) {
      const t = await a.updateCustomer(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Update customers\' discord
     * @param {string} id User ID
     * @param {CustomerDiscordInput} customerDiscordInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateCustomerDiscord(e, r, t) {
      const s = await a.updateCustomerDiscord(e, r, t);
      return E(s, h, d, o);
    },
    /**
     * 
     * @summary Update customers\' onboarding
     * @param {string} id User ID
     * @param {CustomerOnboardingInput} customerOnboardingInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateCustomerOnboarding(e, r, t) {
      const s = await a.updateCustomerOnboarding(e, r, t);
      return E(s, h, d, o);
    },
    /**
     * 
     * @summary Updates a customer\'s segmentation data
     * @param {string} id User ID
     * @param {CustomerSegmentation} customerSegmentation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateCustomerSegmentation(e, r, t) {
      const s = await a.updateCustomerSegmentation(e, r, t);
      return E(s, h, d, o);
    },
    /**
     * 
     * @summary Creates or Updates a customers\' churn
     * @param {string} id User ID
     * @param {CustomerChurnInput} customerChurnInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateOrCreateCustomerChurn(e, r, t) {
      const s = await a.updateOrCreateCustomerChurn(e, r, t);
      return E(s, h, d, o);
    },
    /**
     * 
     * @summary Update a project
     * @param {string} projectId Project ID
     * @param {ProjectInput} [projectInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateProject(e, r, t) {
      const s = await a.updateProject(e, r, t);
      return E(s, h, d, o);
    },
    /**
     * 
     * @summary Create or update security items
     * @param {string} projectId Project ID
     * @param {SecurityType} securityType Security Type
     * @param {SecurityInput} [securityInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSecurityItem(e, r, t, s) {
      const n = await a.updateSecurityItem(e, r, t, s);
      return E(n, h, d, o);
    },
    /**
     * 
     * @summary Updates a user\'s service plan
     * @param {string} id User ID or email
     * @param {string} [promoCode] The promocode to apply
     * @param {ServicePlanInput} [servicePlanInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateServicePlan(e, r, t, s) {
      const n = await a.updateServicePlan(e, r, t, s);
      return E(n, h, d, o);
    },
    /**
     * Flatly updates updated user properties.
     * @summary Updates an existing user
     * @param {string} id User ID or email
     * @param {UserInput} [userInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateUser(e, r, t) {
      const s = await a.updateUser(e, r, t);
      return E(s, h, d, o);
    },
    /**
     * 
     * @summary Updates a card
     * @param {SaveCardInput} saveCardInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async upsertCard(e, r) {
      const t = await a.upsertCard(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Update user\'s wallet id
     * @param {string} id User ID
     * @param {UserWalletInput} userWalletInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async upsertUserWallet(e, r, t) {
      const s = await a.upsertUserWallet(e, r, t);
      return E(s, h, d, o);
    },
    /**
     * 
     * @summary Check MFA Registration
     * @param {MFAVerifyInput} mFAVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyMFA(e, r) {
      const t = await a.verifyMFA(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Check Consent Challenge (oAuth Hydra)
     * @param {OAuthVerifyInput} oAuthVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyOAuthConsent(e, r) {
      const t = await a.verifyOAuthConsent(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Check Login Challenge (oAuth Hydra)
     * @param {OAuthVerifyInput} oAuthVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyOAuthLogin(e, r) {
      const t = await a.verifyOAuthLogin(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Verifies a user\'s token
     * @param {VerifyInput} verifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyUser(e, r) {
      const t = await a.verifyUser(e, r);
      return E(t, h, d, o);
    },
    /**
     * 
     * @summary Logs in a user with wallet
     * @param {WalletLoginInput} walletLoginInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletLogin(e, r) {
      const t = await a.walletLogin(e, r);
      return E(t, h, d, o);
    }
  };
}, Be = function(o, a, e) {
  const r = u(o);
  return {
    /**
     * 
     * @summary Accept Consent Challenge (oAuth Hydra)
     * @param {OAuthAcceptInput} oAuthAcceptInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptOAuthConsent(t, s) {
      return r.acceptOAuthConsent(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Accepts a Login Challenge (oAuth Hydra)
     * @param {OAuthVerifyInput} oAuthVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptOAuthLogin(t, s) {
      return r.acceptOAuthLogin(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Cancels a delayed plan downgrade.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelDowngrade(t) {
      return r.cancelDowngrade(t).then((s) => s(e, a));
    },
    /**
     * 
     * @summary Changes a user\'s email and sends verification
     * @param {ChangeEmailInput} changeEmailInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeEmail(t, s) {
      return r.changeEmail(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Changes a user\'s password
     * @param {ChangePasswordInput} changePasswordInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changePassword(t, s) {
      return r.changePassword(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary It provides a temporary link to the portal specific to each customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCustomerPortalSession(t) {
      return r.createCustomerPortalSession(t).then((s) => s(e, a));
    },
    /**
     * 
     * @summary CreateEvent logs an analytics event to Cloudwatch under the topic `infura.events.web.v1.${req.body.type}`
     * @param {Event} event 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEvent(t, s) {
      return r.createEvent(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Add a new JWT public key
     * @param {string} projectId Project ID
     * @param {JWTPublicKeyInput} [jWTPublicKeyInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createJWTPublicKey(t, s, n) {
      return r.createJWTPublicKey(t, s, n).then((l) => l(e, a));
    },
    /**
     * 
     * @summary Create a new project
     * @param {ProjectInput} [projectInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createProject(t, s) {
      return r.createProject(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Create a new user
     * @param {string} [recaptcha] The recaptcha code
     * @param {string} [challenge] An oauth challenge
     * @param {CreateUserInput} [createUserInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser(t, s, n, l) {
      return r.createUser(t, s, n, l).then((c) => c(e, a));
    },
    /**
     * 
     * @summary Remove an existing JWT public key
     * @param {string} projectId Project ID
     * @param {string} keyId ID of the public key to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteJWTPublicKey(t, s, n) {
      return r.deleteJWTPublicKey(t, s, n).then((l) => l(e, a));
    },
    /**
     * 
     * @summary Delete the mfa registration
     * @param {MFAVerifyInput} mFAVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteMfa(t, s) {
      return r.deleteMfa(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Delete a project
     * @param {string} projectId Project ID
     * @param {MFAVerifyInput} [mFAVerifyInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProject(t, s, n) {
      return r.deleteProject(t, s, n).then((l) => l(e, a));
    },
    /**
     * 
     * @summary Delete security items
     * @param {string} projectId Project ID
     * @param {SecurityType} securityType Security Type
     * @param {SecurityInput} [securityInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteSecurityItem(t, s, n, l) {
      return r.deleteSecurityItem(t, s, n, l).then((c) => c(e, a));
    },
    /**
     * 
     * @summary Deletes a User
     * @param {string} id User ID or email
     * @param {string} [mfaVerificationCode] User MFA verification code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(t, s, n) {
      return r.deleteUser(t, s, n).then((l) => l(e, a));
    },
    /**
     * 
     * @summary Delete user\'s wallet id
     * @param {string} id User ID
     * @param {UserWalletInput} userWalletInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUserWallet(t, s, n) {
      return r.deleteUserWallet(t, s, n).then((l) => l(e, a));
    },
    /**
     * 
     * @summary Enables 2FA
     * @param {MFAVerifyInput} mFAVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enableMFA(t, s) {
      return r.enableMFA(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Get a customers\' churn data
     * @param {string} id User ID
     * @param {number} [limit] response data limit
     * @param {number} [after] get data &#x60;after&#x60; specific count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllCustomerChurn(t, s, n, l) {
      return r.getAllCustomerChurn(t, s, n, l).then((c) => c(e, a));
    },
    /**
     * 
     * @summary GetAnalytics
     * @param {AnalyticsInput} analyticsInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAnalytics(t, s) {
      return r.getAnalytics(t, s).then((n) => n(e, a));
    },
    /**
     * Get blog posts from www.infura.io/blog, passing query params into the ghost posts api.
     * @summary Get the blog posts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBlogPosts(t) {
      return r.getBlogPosts(t).then((s) => s(e, a));
    },
    /**
     * 
     * @summary returns user\'s payment profile (credit-card) from chargify
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getChargifyCard(t) {
      return r.getChargifyCard(t).then((s) => s(e, a));
    },
    /**
     * 
     * @summary Get coupon
     * @param {string} promoCode The promocode to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCoupon(t, s) {
      return r.getCoupon(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Retrieves the details of an existing chargify customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomer(t) {
      return r.getCustomer(t).then((s) => s(e, a));
    },
    /**
     * 
     * @summary Get a customer\'s segmentation data
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerSegmentation(t, s) {
      return r.getCustomerSegmentation(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary GetEthCallActivityStats
     * @param {AnalyticsQuery} analyticsQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEthCallActivityStats(t, s) {
      return r.getEthCallActivityStats(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Gets users\' chargify invoices
     * @param {number} [page] 
     * @param {number} [perPage] 
     * @param {Product} [product] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoices(t, s, n, l) {
      return r.getInvoices(t, s, n, l).then((c) => c(e, a));
    },
    /**
     * 
     * @summary Gets a user identified by Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMe(t) {
      return r.getMe(t).then((s) => s(e, a));
    },
    /**
     * 
     * @summary GetMethodDominanceStats
     * @param {AnalyticsQuery} analyticsQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMethodDominanceStats(t, s) {
      return r.getMethodDominanceStats(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary GetNetworkDominanceStats
     * @param {AnalyticsQuery} analyticsQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNetworkDominanceStats(t, s) {
      return r.getNetworkDominanceStats(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Get the networks that the user has access to for this project
     * @param {string} projectId Project ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNetworks(t, s) {
      return r.getNetworks(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Gets tier and addon offerings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOfferings(t) {
      return r.getOfferings(t).then((s) => s(e, a));
    },
    /**
     * 
     * @summary Get a project
     * @param {string} projectId Project ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProject(t, s) {
      return r.getProject(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary GetRequestActivityStats
     * @param {AnalyticsQuery} analyticsQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRequestActivityStats(t, s) {
      return r.getRequestActivityStats(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary GetRequestVolumeStats
     * @param {AnalyticsQuery} analyticsQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRequestVolumeStats(t, s) {
      return r.getRequestVolumeStats(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Gets users\' stripe invoices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStripeInvoices(t) {
      return r.getStripeInvoices(t).then((s) => s(e, a));
    },
    /**
     * 
     * @summary Retrieves a user\'s Chargify subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscription(t) {
      return r.getSubscription(t).then((s) => s(e, a));
    },
    /**
     * The number of credits that can be used per second, ensuring consistent performance.
     * @summary GetThroughput
     * @param {ThroughputQuery} throughputQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getThroughput(t, s) {
      return r.getThroughput(t, s).then((n) => n(e, a));
    },
    /**
     * Get the total credit usage per method | key | network depending on query
     * @summary GetTotalUsage
     * @param {UsageQuery} usageQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTotalUsage(t, s) {
      return r.getTotalUsage(t, s).then((n) => n(e, a));
    },
    /**
     * Returns a single user
     * @summary Find user by ID
     * @param {string} id User
     * @param {boolean} check Whether or not to check if a user with given email exists
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(t, s, n) {
      return r.getUser(t, s, n).then((l) => l(e, a));
    },
    /**
     * 
     * @summary Get user\'s wallet ids
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserWallets(t, s) {
      return r.getUserWallets(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Link 2FA
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    linkMFA(t) {
      return r.linkMFA(t).then((s) => s(e, a));
    },
    /**
     * 
     * @summary Lists all projects
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listProjects(t) {
      return r.listProjects(t).then((s) => s(e, a));
    },
    /**
     * 
     * @summary Retrieves the request packs compnonent allocation to a user\'s Chargify subscription. Subscription components usually represent addons.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listRequestPackAllocations(t) {
      return r.listRequestPackAllocations(t).then((s) => s(e, a));
    },
    /**
     * 
     * @summary Retrieves all Chargify subscriptions for a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listSubscriptions(t) {
      return r.listSubscriptions(t).then((s) => s(e, a));
    },
    /**
     * 
     * @summary Logs in a user
     * @param {LoginInput} loginInput 
     * @param {string} [challenge] An oauth challenge
     * @param {string} [recaptcha] The recaptcha code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login(t, s, n, l) {
      return r.login(t, s, n, l).then((c) => c(e, a));
    },
    /**
     * 
     * @summary Logs out a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout(t) {
      return r.logout(t).then((s) => s(e, a));
    },
    /**
     * 
     * @summary Preview Chargify Subscription
     * @param {PreviewSubscriptionRequest} previewSubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    previewSubscription(t, s) {
      return r.previewSubscription(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Creates support ticket for customers\' 2FA-enabled accounts with no backup code.
     * @param {RecoverMFAInput} recoverMFAInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recoverMFA(t, s) {
      return r.recoverMFA(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Reject Consent Challenge (oAuth Hydra)
     * @param {OAuthVerifyInput} oAuthVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rejectOAuthConsent(t, s) {
      return r.rejectOAuthConsent(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Delete pinned object(s)
     * @param {string} projectId IPFS project ID
     * @param {Array<string>} arg Paths to objects(s) to be unpinned.
     * @param {string} projectSecret The project secret
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removePins(t, s, n, l) {
      return r.removePins(t, s, n, l).then((c) => c(e, a));
    },
    /**
     * 
     * @summary Resends an verification link for updating email
     * @param {EmptyMessage} [emptyMessage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendUpdateEmail(t, s) {
      return r.resendUpdateEmail(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Resends an account verification email
     * @param {EmptyMessage} [emptyMessage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendVerification(t, s) {
      return r.resendVerification(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Check MFA Registration
     * @param {MFAResetInput} mFAResetInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetMFA(t, s) {
      return r.resetMFA(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Resets a user\'s password after sending forgot email
     * @param {ResetPasswordInput} resetPasswordInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(t, s) {
      return r.resetPassword(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Retries a canceled Chargify subscription
     * @param {RetrySubscriptionRequest} retrySubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrySubscription(t, s) {
      return r.retrySubscription(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Send first request
     * @param {CustomerOnboardingFirstRequestInput} customerOnboardingFirstRequestInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendFirstRequest(t, s) {
      return r.sendFirstRequest(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Sends a reset password email
     * @param {SendResetPasswordInput} sendResetPasswordInput 
     * @param {string} [recaptcha] The recaptcha code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendForgotEmail(t, s, n) {
      return r.sendForgotEmail(t, s, n).then((l) => l(e, a));
    },
    /**
     * 
     * @summary Remove the servo addon from the user\'s service plan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uksAddonServoDelete(t) {
      return r.uksAddonServoDelete(t).then((s) => s(e, a));
    },
    /**
     * 
     * @summary Add the servo addon to the user\'s service plan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uksAddonServoPut(t) {
      return r.uksAddonServoPut(t).then((s) => s(e, a));
    },
    /**
     * 
     * @summary Updates card billing info
     * @param {CardBillingInfoInput} cardBillingInfoInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCardBillingInfo(t, s) {
      return r.updateCardBillingInfo(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Updates the details of an existing chargify customer
     * @param {UpdateCustomerInput} updateCustomerInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCustomer(t, s) {
      return r.updateCustomer(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Update customers\' discord
     * @param {string} id User ID
     * @param {CustomerDiscordInput} customerDiscordInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCustomerDiscord(t, s, n) {
      return r.updateCustomerDiscord(t, s, n).then((l) => l(e, a));
    },
    /**
     * 
     * @summary Update customers\' onboarding
     * @param {string} id User ID
     * @param {CustomerOnboardingInput} customerOnboardingInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCustomerOnboarding(t, s, n) {
      return r.updateCustomerOnboarding(t, s, n).then((l) => l(e, a));
    },
    /**
     * 
     * @summary Updates a customer\'s segmentation data
     * @param {string} id User ID
     * @param {CustomerSegmentation} customerSegmentation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCustomerSegmentation(t, s, n) {
      return r.updateCustomerSegmentation(t, s, n).then((l) => l(e, a));
    },
    /**
     * 
     * @summary Creates or Updates a customers\' churn
     * @param {string} id User ID
     * @param {CustomerChurnInput} customerChurnInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrCreateCustomerChurn(t, s, n) {
      return r.updateOrCreateCustomerChurn(t, s, n).then((l) => l(e, a));
    },
    /**
     * 
     * @summary Update a project
     * @param {string} projectId Project ID
     * @param {ProjectInput} [projectInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProject(t, s, n) {
      return r.updateProject(t, s, n).then((l) => l(e, a));
    },
    /**
     * 
     * @summary Create or update security items
     * @param {string} projectId Project ID
     * @param {SecurityType} securityType Security Type
     * @param {SecurityInput} [securityInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSecurityItem(t, s, n, l) {
      return r.updateSecurityItem(t, s, n, l).then((c) => c(e, a));
    },
    /**
     * 
     * @summary Updates a user\'s service plan
     * @param {string} id User ID or email
     * @param {string} [promoCode] The promocode to apply
     * @param {ServicePlanInput} [servicePlanInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateServicePlan(t, s, n, l) {
      return r.updateServicePlan(t, s, n, l).then((c) => c(e, a));
    },
    /**
     * Flatly updates updated user properties.
     * @summary Updates an existing user
     * @param {string} id User ID or email
     * @param {UserInput} [userInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser(t, s, n) {
      return r.updateUser(t, s, n).then((l) => l(e, a));
    },
    /**
     * 
     * @summary Updates a card
     * @param {SaveCardInput} saveCardInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertCard(t, s) {
      return r.upsertCard(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Update user\'s wallet id
     * @param {string} id User ID
     * @param {UserWalletInput} userWalletInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertUserWallet(t, s, n) {
      return r.upsertUserWallet(t, s, n).then((l) => l(e, a));
    },
    /**
     * 
     * @summary Check MFA Registration
     * @param {MFAVerifyInput} mFAVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyMFA(t, s) {
      return r.verifyMFA(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Check Consent Challenge (oAuth Hydra)
     * @param {OAuthVerifyInput} oAuthVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyOAuthConsent(t, s) {
      return r.verifyOAuthConsent(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Check Login Challenge (oAuth Hydra)
     * @param {OAuthVerifyInput} oAuthVerifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyOAuthLogin(t, s) {
      return r.verifyOAuthLogin(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Verifies a user\'s token
     * @param {VerifyInput} verifyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyUser(t, s) {
      return r.verifyUser(t, s).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Logs in a user with wallet
     * @param {WalletLoginInput} walletLoginInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletLogin(t, s) {
      return r.walletLogin(t, s).then((n) => n(e, a));
    }
  };
};
class De extends S {
  /**
   * 
   * @summary Accept Consent Challenge (oAuth Hydra)
   * @param {OAuthAcceptInput} oAuthAcceptInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  acceptOAuthConsent(a, e) {
    return u(this.configuration).acceptOAuthConsent(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Accepts a Login Challenge (oAuth Hydra)
   * @param {OAuthVerifyInput} oAuthVerifyInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  acceptOAuthLogin(a, e) {
    return u(this.configuration).acceptOAuthLogin(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Cancels a delayed plan downgrade.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  cancelDowngrade(a) {
    return u(this.configuration).cancelDowngrade(a).then((e) => e(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Changes a user\'s email and sends verification
   * @param {ChangeEmailInput} changeEmailInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  changeEmail(a, e) {
    return u(this.configuration).changeEmail(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Changes a user\'s password
   * @param {ChangePasswordInput} changePasswordInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  changePassword(a, e) {
    return u(this.configuration).changePassword(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary It provides a temporary link to the portal specific to each customer
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  createCustomerPortalSession(a) {
    return u(this.configuration).createCustomerPortalSession(a).then((e) => e(this.axios, this.basePath));
  }
  /**
   * 
   * @summary CreateEvent logs an analytics event to Cloudwatch under the topic `infura.events.web.v1.${req.body.type}`
   * @param {Event} event 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  createEvent(a, e) {
    return u(this.configuration).createEvent(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Add a new JWT public key
   * @param {string} projectId Project ID
   * @param {JWTPublicKeyInput} [jWTPublicKeyInput] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  createJWTPublicKey(a, e, r) {
    return u(this.configuration).createJWTPublicKey(a, e, r).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Create a new project
   * @param {ProjectInput} [projectInput] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  createProject(a, e) {
    return u(this.configuration).createProject(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Create a new user
   * @param {string} [recaptcha] The recaptcha code
   * @param {string} [challenge] An oauth challenge
   * @param {CreateUserInput} [createUserInput] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  createUser(a, e, r, t) {
    return u(this.configuration).createUser(a, e, r, t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Remove an existing JWT public key
   * @param {string} projectId Project ID
   * @param {string} keyId ID of the public key to remove
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  deleteJWTPublicKey(a, e, r) {
    return u(this.configuration).deleteJWTPublicKey(a, e, r).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Delete the mfa registration
   * @param {MFAVerifyInput} mFAVerifyInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  deleteMfa(a, e) {
    return u(this.configuration).deleteMfa(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Delete a project
   * @param {string} projectId Project ID
   * @param {MFAVerifyInput} [mFAVerifyInput] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  deleteProject(a, e, r) {
    return u(this.configuration).deleteProject(a, e, r).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Delete security items
   * @param {string} projectId Project ID
   * @param {SecurityType} securityType Security Type
   * @param {SecurityInput} [securityInput] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  deleteSecurityItem(a, e, r, t) {
    return u(this.configuration).deleteSecurityItem(a, e, r, t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Deletes a User
   * @param {string} id User ID or email
   * @param {string} [mfaVerificationCode] User MFA verification code
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  deleteUser(a, e, r) {
    return u(this.configuration).deleteUser(a, e, r).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Delete user\'s wallet id
   * @param {string} id User ID
   * @param {UserWalletInput} userWalletInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  deleteUserWallet(a, e, r) {
    return u(this.configuration).deleteUserWallet(a, e, r).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Enables 2FA
   * @param {MFAVerifyInput} mFAVerifyInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  enableMFA(a, e) {
    return u(this.configuration).enableMFA(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get a customers\' churn data
   * @param {string} id User ID
   * @param {number} [limit] response data limit
   * @param {number} [after] get data &#x60;after&#x60; specific count
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getAllCustomerChurn(a, e, r, t) {
    return u(this.configuration).getAllCustomerChurn(a, e, r, t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary GetAnalytics
   * @param {AnalyticsInput} analyticsInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getAnalytics(a, e) {
    return u(this.configuration).getAnalytics(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Get blog posts from www.infura.io/blog, passing query params into the ghost posts api.
   * @summary Get the blog posts
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getBlogPosts(a) {
    return u(this.configuration).getBlogPosts(a).then((e) => e(this.axios, this.basePath));
  }
  /**
   * 
   * @summary returns user\'s payment profile (credit-card) from chargify
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getChargifyCard(a) {
    return u(this.configuration).getChargifyCard(a).then((e) => e(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get coupon
   * @param {string} promoCode The promocode to retrieve
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getCoupon(a, e) {
    return u(this.configuration).getCoupon(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Retrieves the details of an existing chargify customer
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getCustomer(a) {
    return u(this.configuration).getCustomer(a).then((e) => e(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get a customer\'s segmentation data
   * @param {string} id User ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getCustomerSegmentation(a, e) {
    return u(this.configuration).getCustomerSegmentation(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary GetEthCallActivityStats
   * @param {AnalyticsQuery} analyticsQuery 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getEthCallActivityStats(a, e) {
    return u(this.configuration).getEthCallActivityStats(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Gets users\' chargify invoices
   * @param {number} [page] 
   * @param {number} [perPage] 
   * @param {Product} [product] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getInvoices(a, e, r, t) {
    return u(this.configuration).getInvoices(a, e, r, t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Gets a user identified by Token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getMe(a) {
    return u(this.configuration).getMe(a).then((e) => e(this.axios, this.basePath));
  }
  /**
   * 
   * @summary GetMethodDominanceStats
   * @param {AnalyticsQuery} analyticsQuery 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getMethodDominanceStats(a, e) {
    return u(this.configuration).getMethodDominanceStats(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary GetNetworkDominanceStats
   * @param {AnalyticsQuery} analyticsQuery 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getNetworkDominanceStats(a, e) {
    return u(this.configuration).getNetworkDominanceStats(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get the networks that the user has access to for this project
   * @param {string} projectId Project ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getNetworks(a, e) {
    return u(this.configuration).getNetworks(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Gets tier and addon offerings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getOfferings(a) {
    return u(this.configuration).getOfferings(a).then((e) => e(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get a project
   * @param {string} projectId Project ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getProject(a, e) {
    return u(this.configuration).getProject(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary GetRequestActivityStats
   * @param {AnalyticsQuery} analyticsQuery 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getRequestActivityStats(a, e) {
    return u(this.configuration).getRequestActivityStats(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary GetRequestVolumeStats
   * @param {AnalyticsQuery} analyticsQuery 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getRequestVolumeStats(a, e) {
    return u(this.configuration).getRequestVolumeStats(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Gets users\' stripe invoices
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getStripeInvoices(a) {
    return u(this.configuration).getStripeInvoices(a).then((e) => e(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Retrieves a user\'s Chargify subscription
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getSubscription(a) {
    return u(this.configuration).getSubscription(a).then((e) => e(this.axios, this.basePath));
  }
  /**
   * The number of credits that can be used per second, ensuring consistent performance.
   * @summary GetThroughput
   * @param {ThroughputQuery} throughputQuery 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getThroughput(a, e) {
    return u(this.configuration).getThroughput(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Get the total credit usage per method | key | network depending on query
   * @summary GetTotalUsage
   * @param {UsageQuery} usageQuery 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getTotalUsage(a, e) {
    return u(this.configuration).getTotalUsage(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Returns a single user
   * @summary Find user by ID
   * @param {string} id User
   * @param {boolean} check Whether or not to check if a user with given email exists
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getUser(a, e, r) {
    return u(this.configuration).getUser(a, e, r).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get user\'s wallet ids
   * @param {string} id User ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getUserWallets(a, e) {
    return u(this.configuration).getUserWallets(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Link 2FA
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  linkMFA(a) {
    return u(this.configuration).linkMFA(a).then((e) => e(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Lists all projects
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  listProjects(a) {
    return u(this.configuration).listProjects(a).then((e) => e(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Retrieves the request packs compnonent allocation to a user\'s Chargify subscription. Subscription components usually represent addons.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  listRequestPackAllocations(a) {
    return u(this.configuration).listRequestPackAllocations(a).then((e) => e(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Retrieves all Chargify subscriptions for a user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  listSubscriptions(a) {
    return u(this.configuration).listSubscriptions(a).then((e) => e(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Logs in a user
   * @param {LoginInput} loginInput 
   * @param {string} [challenge] An oauth challenge
   * @param {string} [recaptcha] The recaptcha code
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  login(a, e, r, t) {
    return u(this.configuration).login(a, e, r, t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Logs out a user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  logout(a) {
    return u(this.configuration).logout(a).then((e) => e(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Preview Chargify Subscription
   * @param {PreviewSubscriptionRequest} previewSubscriptionRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  previewSubscription(a, e) {
    return u(this.configuration).previewSubscription(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Creates support ticket for customers\' 2FA-enabled accounts with no backup code.
   * @param {RecoverMFAInput} recoverMFAInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  recoverMFA(a, e) {
    return u(this.configuration).recoverMFA(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Reject Consent Challenge (oAuth Hydra)
   * @param {OAuthVerifyInput} oAuthVerifyInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  rejectOAuthConsent(a, e) {
    return u(this.configuration).rejectOAuthConsent(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Delete pinned object(s)
   * @param {string} projectId IPFS project ID
   * @param {Array<string>} arg Paths to objects(s) to be unpinned.
   * @param {string} projectSecret The project secret
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  removePins(a, e, r, t) {
    return u(this.configuration).removePins(a, e, r, t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Resends an verification link for updating email
   * @param {EmptyMessage} [emptyMessage] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  resendUpdateEmail(a, e) {
    return u(this.configuration).resendUpdateEmail(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Resends an account verification email
   * @param {EmptyMessage} [emptyMessage] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  resendVerification(a, e) {
    return u(this.configuration).resendVerification(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Check MFA Registration
   * @param {MFAResetInput} mFAResetInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  resetMFA(a, e) {
    return u(this.configuration).resetMFA(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Resets a user\'s password after sending forgot email
   * @param {ResetPasswordInput} resetPasswordInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  resetPassword(a, e) {
    return u(this.configuration).resetPassword(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Retries a canceled Chargify subscription
   * @param {RetrySubscriptionRequest} retrySubscriptionRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  retrySubscription(a, e) {
    return u(this.configuration).retrySubscription(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Send first request
   * @param {CustomerOnboardingFirstRequestInput} customerOnboardingFirstRequestInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  sendFirstRequest(a, e) {
    return u(this.configuration).sendFirstRequest(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Sends a reset password email
   * @param {SendResetPasswordInput} sendResetPasswordInput 
   * @param {string} [recaptcha] The recaptcha code
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  sendForgotEmail(a, e, r) {
    return u(this.configuration).sendForgotEmail(a, e, r).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Remove the servo addon from the user\'s service plan
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  uksAddonServoDelete(a) {
    return u(this.configuration).uksAddonServoDelete(a).then((e) => e(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Add the servo addon to the user\'s service plan
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  uksAddonServoPut(a) {
    return u(this.configuration).uksAddonServoPut(a).then((e) => e(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updates card billing info
   * @param {CardBillingInfoInput} cardBillingInfoInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  updateCardBillingInfo(a, e) {
    return u(this.configuration).updateCardBillingInfo(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updates the details of an existing chargify customer
   * @param {UpdateCustomerInput} updateCustomerInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  updateCustomer(a, e) {
    return u(this.configuration).updateCustomer(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update customers\' discord
   * @param {string} id User ID
   * @param {CustomerDiscordInput} customerDiscordInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  updateCustomerDiscord(a, e, r) {
    return u(this.configuration).updateCustomerDiscord(a, e, r).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update customers\' onboarding
   * @param {string} id User ID
   * @param {CustomerOnboardingInput} customerOnboardingInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  updateCustomerOnboarding(a, e, r) {
    return u(this.configuration).updateCustomerOnboarding(a, e, r).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updates a customer\'s segmentation data
   * @param {string} id User ID
   * @param {CustomerSegmentation} customerSegmentation 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  updateCustomerSegmentation(a, e, r) {
    return u(this.configuration).updateCustomerSegmentation(a, e, r).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Creates or Updates a customers\' churn
   * @param {string} id User ID
   * @param {CustomerChurnInput} customerChurnInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  updateOrCreateCustomerChurn(a, e, r) {
    return u(this.configuration).updateOrCreateCustomerChurn(a, e, r).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update a project
   * @param {string} projectId Project ID
   * @param {ProjectInput} [projectInput] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  updateProject(a, e, r) {
    return u(this.configuration).updateProject(a, e, r).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Create or update security items
   * @param {string} projectId Project ID
   * @param {SecurityType} securityType Security Type
   * @param {SecurityInput} [securityInput] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  updateSecurityItem(a, e, r, t) {
    return u(this.configuration).updateSecurityItem(a, e, r, t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updates a user\'s service plan
   * @param {string} id User ID or email
   * @param {string} [promoCode] The promocode to apply
   * @param {ServicePlanInput} [servicePlanInput] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  updateServicePlan(a, e, r, t) {
    return u(this.configuration).updateServicePlan(a, e, r, t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * Flatly updates updated user properties.
   * @summary Updates an existing user
   * @param {string} id User ID or email
   * @param {UserInput} [userInput] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  updateUser(a, e, r) {
    return u(this.configuration).updateUser(a, e, r).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updates a card
   * @param {SaveCardInput} saveCardInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  upsertCard(a, e) {
    return u(this.configuration).upsertCard(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update user\'s wallet id
   * @param {string} id User ID
   * @param {UserWalletInput} userWalletInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  upsertUserWallet(a, e, r) {
    return u(this.configuration).upsertUserWallet(a, e, r).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Check MFA Registration
   * @param {MFAVerifyInput} mFAVerifyInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  verifyMFA(a, e) {
    return u(this.configuration).verifyMFA(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Check Consent Challenge (oAuth Hydra)
   * @param {OAuthVerifyInput} oAuthVerifyInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  verifyOAuthConsent(a, e) {
    return u(this.configuration).verifyOAuthConsent(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Check Login Challenge (oAuth Hydra)
   * @param {OAuthVerifyInput} oAuthVerifyInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  verifyOAuthLogin(a, e) {
    return u(this.configuration).verifyOAuthLogin(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Verifies a user\'s token
   * @param {VerifyInput} verifyInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  verifyUser(a, e) {
    return u(this.configuration).verifyUser(a, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Logs in a user with wallet
   * @param {WalletLoginInput} walletLoginInput 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  walletLogin(a, e) {
    return u(this.configuration).walletLogin(a, e).then((r) => r(this.axios, this.basePath));
  }
}
class Fe {
  constructor(a = {}) {
    /**
     * parameter for apiKey security
     * @param name security name
     * @memberof Configuration
     */
    y(this, "apiKey");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    y(this, "username");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    y(this, "password");
    /**
     * parameter for oauth2 security
     * @param name security name
     * @param scopes oauth2 scope
     * @memberof Configuration
     */
    y(this, "accessToken");
    /**
     * override base path
     *
     * @type {string}
     * @memberof Configuration
     */
    y(this, "basePath");
    /**
     * base options for axios calls
     *
     * @type {any}
     * @memberof Configuration
     */
    y(this, "baseOptions");
    /**
     * The FormData constructor that will be used to create multipart form data
     * requests. You can inject this here so that execution environments that
     * do not support the FormData class can still run the generated client.
     *
     * @type {new () => FormData}
     */
    y(this, "formDataCtor");
    this.apiKey = a.apiKey, this.username = a.username, this.password = a.password, this.accessToken = a.accessToken, this.basePath = a.basePath, this.baseOptions = a.baseOptions, this.formDataCtor = a.formDataCtor;
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(a) {
    const e = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return a !== null && (e.test(a) || a.toLowerCase() === "application/json-patch+json");
  }
}
export {
  N as AdminProjectEntityTypeEnum,
  L as AnalyticsForIncludeEnum,
  w as AnalyticsQueryDatapointEnum,
  j as AnalyticsQueryQueryEnum,
  H as AnalyticsTimeTickEnum,
  B as AnyProjectEntityTypeEnum,
  D as BankAccountCurrentVaultEnum,
  F as BaseProject1EntityTypeEnum,
  v as CardType,
  M as ChargeType,
  q as ChargifyCouponCompoundingStrategyEnum,
  x as ChargifyCouponCouponRestrictionsInnerItemTypeEnum,
  Q as ChargifyCouponDiscountTypeEnum,
  G as ChargifyCouponRecurringSchemeEnum,
  k as ChurnType,
  Fe as Configuration,
  f as CouponCompoundingStrategyEnum,
  K as CouponDiscountTypeEnum,
  W as CouponRecurringSchemeEnum,
  Y as CreditCardCurrentVaultEnum,
  De as DefaultApi,
  b as DefaultApiAxiosParamCreator,
  Be as DefaultApiFactory,
  u as DefaultApiFp,
  $ as ErrorCode,
  J as EventType,
  X as InfuraChargifyCoreProductComponentHandles,
  z as InfuraChargifyCoreProductHandles,
  Z as InfuraChargifyFreeProductHandles,
  ee as InfuraPlusStatusTermsEnum,
  te as InvoiceCollectionMethodEnum,
  ae as InvoiceConsolidationLevelEnum,
  re as InvoiceStatus,
  se as IpfsProjectEntityTypeEnum,
  ne as ItemCategory,
  oe as MethodType,
  le as Network,
  ce as NetworkType,
  ie as OAuthConsentVerifyDataRequestedScopeEnum,
  he as OrganisationCategory,
  de as OrganisationSize,
  ue as PaymentType,
  pe as Product,
  Oe as Product1ExpirationIntervalUnitEnum,
  me as Product1IntervalUnitEnum,
  Ee as Product1TrialIntervalUnitEnum,
  Ae as ProjectRole,
  Te as SecurityType,
  Pe as ServiceAddon,
  Ve as ServiceTier,
  ye as SubscriptionCancellationMethodEnum,
  _e as SubscriptionPaymentCollectionMethodEnum,
  Ce as SubscriptionState,
  Re as ThroughputQueryDatapointEnum,
  Se as ThroughputQueryQueryEnum,
  Ue as ThroughputTimeFromEnum,
  be as ThroughputTimeTickEnum,
  ge as UsageForIncludeEnum,
  Ie as UsageQueryDatapointEnum,
  Ne as UsageQueryQueryEnum,
  Le as UsageTimeTickEnum,
  je as User1RelationshipEnum,
  we as UserRelationshipEnum,
  He as UserRole
};
